import { Facebook, Instagram, Leaf, Link2 } from "lucide-react";
import { useLang } from "../LanguageContext";
import { scrollToId } from "../scroll";

const SECTION_IDS = ["chi-sono", "competenze", "perche", "testimonianze", "libri", "contatti"];

const Footer = () => {
  const { t } = useLang();
  const labels = [t.nav.about, t.nav.disciplines, t.nav.why, t.nav.testimonials, t.nav.books, t.nav.contact];

  return (
    <footer data-testid="footer" className="relative overflow-hidden border-t border-linen/10 bg-forest pb-12 pt-20 text-linen">
      <span aria-hidden className="pointer-events-none absolute -bottom-10 left-0 select-none font-serif text-[22vw] font-light italic leading-none text-olive/25">
        Armonia
      </span>
      <div className="relative mx-auto max-w-7xl px-6 sm:px-8 lg:px-12">
        <div className="flex flex-col gap-12 md:flex-row md:items-start md:justify-between">
          <div>
            <div className="flex items-center gap-2.5">
              <Leaf className="h-5 w-5 text-gold" strokeWidth={1.5} />
              <span className="font-serif text-2xl font-light tracking-tight">Eros Zannoni</span>
            </div>
            <p className="mt-4 max-w-xs font-serif text-lg font-light italic text-linen/60">{t.footer.tagline}</p>
            <div className="mt-6 flex gap-3">
              <a
                data-testid="footer-facebook-link"
                href="https://www.facebook.com/eros.zannoni"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
                className="rounded-full border border-linen/20 p-2.5 transition-colors duration-300 hover:border-gold hover:text-gold"
              >
                <Facebook className="h-4 w-4" strokeWidth={1.5} />
              </a>
              <a
                data-testid="footer-instagram-link"
                href="https://www.instagram.com/eros_zannoni"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="rounded-full border border-linen/20 p-2.5 transition-colors duration-300 hover:border-gold hover:text-gold"
              >
                <Instagram className="h-4 w-4" strokeWidth={1.5} />
              </a>
              <a
                data-testid="footer-linktree-link"
                href="https://linktr.ee/MetodoSynergyA"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Linktree"
                className="rounded-full border border-linen/20 p-2.5 transition-colors duration-300 hover:border-gold hover:text-gold"
              >
                <Link2 className="h-4 w-4" strokeWidth={1.5} />
              </a>
            </div>
          </div>
          <nav className="grid grid-cols-2 gap-x-16 gap-y-3">
            {labels.map((label, i) => (
              <button
                key={SECTION_IDS[i]}
                data-testid={`footer-link-${SECTION_IDS[i]}`}
                onClick={() => scrollToId(SECTION_IDS[i])}
                className="text-left font-mono text-[11px] uppercase tracking-[0.2em] text-linen/60 transition-colors duration-300 hover:text-gold"
              >
                {label}
              </button>
            ))}
          </nav>
        </div>
        <p className="mt-16 border-t border-linen/10 pt-8 font-mono text-[10px] uppercase tracking-[0.2em] text-linen/40">
          {t.footer.rights}
        </p>
      </div>
    </footer>
  );
};

export default Footer;
